module.exports = __webpack_public_path__ + "static/media/ComexBg.ead13637.png";